// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Z0PFnp6ByG4r8fqAMwJI{align-items:center;gap:20px;min-height:32px;margin:0 8px 0 17px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Z0PFnp6ByG4r8fqAMwJI`
};
export default ___CSS_LOADER_EXPORT___;
